// for a legacy code and future fixes
module.exports = function () {
  return Function.call.apply(Array.prototype.concat, arguments);
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/array/concat.js
// module id = 731
// module chunks = 1